export const onlyLegalFlowCountry = ['UA', 'UM', 'US']
